var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVoted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5.9375V24.9375H28.5V5.9375H9.5ZM11.875 8.3125H26.125V22.5625H11.875V8.3125ZM22.9187 11.7562L17.8125 16.8625L15.0812 14.1312L13.4188 15.9125L16.9813 19.475L17.8125 20.3063L18.6437 19.475L24.5813 13.5375L22.9187 11.7562ZM2.375 22.5625V32.0625H4.75V24.9375H7.125V22.5625H2.375ZM30.875 22.5625V24.9375H33.25V32.0625H35.625V22.5625H30.875ZM7.125 27.3125V29.6875H30.875V27.3125H7.125Z",
    fill: "#636363"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoted);
export default __webpack_public_path__ + "static/media/voted.539dfcf5d7b5ebfd8ac751942b631534.svg";
export { ForwardRef as ReactComponent };